module.exports = __webpack_public_path__ + "static/GorditaBlack-BlackItalic-78d5221936284219736abb42425e1136.woff2";